import { parseSafeHtml } from '../../utils/safe-html';

type Props = {
  heading: string;
  insetContent: string | undefined;
};

function Inset({ insetContent }: Props) {
  return <div className="govuk-inset-text">{parseSafeHtml(insetContent)}</div>;
}

export default Inset;
